// eslint-disable-next-line import/prefer-default-export
import { queryBot } from 'boot/axios';
import unescapeSql from 'src/mixins/utils';

// eslint-disable-next-line import/prefer-default-export
export class Billing {
    constructor (app) {
        this.app = app;
    }

    /**
     * Пополнить баланс пользователя, если userId не указан - то будет пополнен баланс текущего пользователя
     * @payload = {
     *     amount: Number - сумма пополнения
     *     title: String[255] - название операции
     *     comment: String - комментарий
     *     author: String - ФИО ответственного
     * }
     * @userId
     */
    addToBalance (payload, userId) {
        return new Promise((resolve, reject) => {
            if (!payload.amount) {
                reject('Сумма не указана');
                return;
            }
            if (+payload.amount === 0) {
                reject('Сумма пополнения не может быть равна нулю');
                return;
            }
            if (!userId) {
                const user = this.getUser();
                if (!user) {
                    reject('addToBalance: current user not found');
                    return;
                }
                userId = user.id;
            }
            let balanceAfter = 0;
            this.getBalance(userId).then((r) => {
                balanceAfter = +r.data[0].balance + +payload.amount;
                this.updateBalance(userId, payload.amount).then((r2) => {
                    if (r2.data.id === 'OK') {
                        const sql = 'INSERT INTO balance_transactions (user_id, amount, title, comment, balance_after, type, user_product_id, author) VALUES ('
                            + ` ${userId}, `
                            + ` '${payload.amount}', `
                            + ` '${unescapeSql(payload.title || '')}', `
                            + ` '${unescapeSql(payload.comment || '')}', `
                            + ` '${balanceAfter}', `
                            + ` '${payload.type || '0'}', `
                            + ` '${payload.userProductId || ''}', `
                            + ` '${unescapeSql(payload.author || '')}') `;
                        queryBot(sql).then(() => {
                            resolve(parseFloat(balanceAfter).toFixed(2));
                        });
                    } else {
                        reject('Cannot update balance: query error');
                    }
                });
            });
        });
    }

    /**
     * Списать с баланса пользователя, если userId не указан - то списание будет выполнено с баланса текущего пользователя
     * @payload = {
     *     amount: Number - сумма списания
     *     title: String[255] - название операции
     *     comment: String - комментарий
     *     author: String - ФИО ответственного
     * }
     * @userId
     */
    spend (payload, userId) {
        if (payload.amount) {
            payload.amount = +payload.amount * -1;
        }
        return this.addToBalance(payload, userId);
    }

    // eslint-disable-next-line class-methods-use-this
    getBalance (userId) {
        return queryBot(`select balance from users where id = ${userId}`);
    }

    // eslint-disable-next-line class-methods-use-this
    updateBalance (userId, amount) {
        return queryBot(`update users set balance = balance + ${amount} where id = ${userId}`);
    }

    getUser () {
        return this.app.$store.state.pages.user;
    }
}
